export class RULES {
	static ISOLVE_ACIONAMENTO_MODAL_USUARIO = 'Isolve.Acionamento.ModalUsuario'
	static ISOLVE_ACIONAMENTO_MODAL_ANALISTA_ATTA = 'Isolve.Acionamento.ModalAnalistaATTA'
	static ISOLVE_PROPOSTA_QUINTOANDAR = 'Isolve.Proposta.QuintoAndar'
	static ISOLVE_GERAL_NOVAESTEIRA = 'Isolve.Geral.Novaesteira'
	static ISOLVE_FORMULARIO_MULTIBANCOS_CORRETOR_5A_HUBS = 'Isolve.FormularioMultibanco.CampoCorretor5AHUBS'
	static ISOLVE_GERAL_BANRISUL = 'Isolve.Geral.FornecedorBanrisul'
	static ISOLVE_GERAL_CAIXA = 'Isolve.Geral.FornecedorCaixa'
	static ISOLVE_PARCEIRO_ADMINISTRADOR = 'Isolve.Parceiros.Administrador'
	static ISOLVE_PARCEIRO_COMPLIANCE = 'Isolve.Parceiros.Compliance'
	static ISOLVE_PARCEIRO_FRANQUEADO = 'Isolve.Parceiros.Franqueado'
	static ISOLVE_PARCEIRO_CONSULTOR = 'Isolve.Parceiros.Consultor'
	static ISOLVE_PARCEIRO_USUARIO = 'Isolve.Parceiros.Usuario'
	static ISOLVE_PREANALISE_5AEXIBIRCAMPOS = 'Isolve.PreAnalise.5AExibirCampos'
	static ISOLVE_PROPOSTAS_COLUNA_CANAL = 'Isolve.MinhasPropostas.ColunaCanal'
	static ISOLVE_PROPOSTAS_ROTINA_ADMINISTRATIVA = 'Isolve.Proposta.RotinaAdministrativa'
	static ISOLVE_DOCUMENTOS_APROVAR_REPROVAR = 'Isolve.Documentos.AprovarReprovar'

	// RULES MENU
	static ISOLVE_MENU_SIMULADOR = 'Isolve.MenuIsolve.Simulador'
	static ISOLVE_MENU_DASHBOARD = 'Isolve.MenuIsolve.Dashboards'
	static ISOLVE_MENU_PRE_ANALISE = 'Isolve.MenuIsolve.PreAnalise'
	static ISOLVE_MENU_PROPOSTAS = 'Isolve.MenuIsolve.MinhasPropostas'
	static ISOLVE_MENU_OPERACIONAL = 'Isolve.MenuIsolve.Operacional'
	static ISOLVE_MENU_ANALISE_CREDITO = 'Isolve.MenuIsolve.AnaliseDeCredito'
	static ISOLVE_MENU_SEGURO_INCENDIO = 'Isolve.MenuIsolve.SeguroIncendio'
	static ISOLVE_MENU_FIANCA_LOCATICIA = 'Isolve.MenuIsolve.FiancaLocaticia'
	static ISOLVE_MENU_CARTA_FIANCA = 'Isolve.MenuIsolve.CartaFianca'
	static ISOLVE_MENU_CAPITALIZACAO = 'Isolve.MenuIsolve.Capitalizacao'
	static ISOLVE_MENU_ADM_USERS = 'Isolve.MenuIsolve.AdmUsuarios'
	static ISOLVE_MENU_ADM_PARCEIROS = 'Isolve.MenuIsolve.AdmParceiros'
	static ISOLVE_MENU_ADM_FRANQUIAS = 'Isolve.MenuIsolve.AdmFranquias'
	static ISOLVE_MENU_ADM_PARAMETRIZACAO = 'Isolve.MenuIsolve.AdmParametrizacoes'
	static ISOLVE_MENU_ADM_INTEGRACAO = 'Isolve.MenuIsolve.AdmIntegracoes'
	static ISOLVE_MENU_ADM_ROTINAS = 'Isolve.MenuIsolve.AdmRotinas'
	static ISOLVE_MENU_ADM_ACIONAMENTO = 'Isolve.MenuIsolve.AdmAcionamento'
	static ISOLVE_MENU_CUSTOMER_SATISFACTION = 'Isolve.MenuIsolve.SatisfacaoDoCliente'
	static ISOLVE_MENU_CLOSING = 'Isolve.MenuIsolve.FechamentoFinanceiro'

	static COMISSOES_ADMINISTRATIVO_VISAO_GERENTE = 'Comissoes.Adiministrativo.VisaoGerente'
	static COMISSOES_ADMINISTRATIVO_VISAO_CONSULTOR = 'Comissoes.Adiministrativo.VisaoConsultor'
	static COMISSOES_ADMINISTRATIVO_VISAO_PARCEIROS = 'Comissoes.Adiministrativo.VisaoParceiros'
	static ISOLVE_MENU_PROJECAO_COMISSIONAMENTO = 'Isolve.MenuIsolve.DashboardProjecaoComissionamento'
	static ISOLVE_MENU_DECISOES_EXTERNAS = 'Isolve.MenuIsolve.DecisoesExternas'
	static ISOLVE_MENU_ADM_GESTAO_CORRETORES = 'Isolve.MenuIsolve.AdmGestaoDeCorretores'
	static ISOLVE_MENU_ADM_MONITORAMENTO_ROBOS = 'Isolve.MenuIsolve.AdmMonitoramentoRobos'

	// RULES VISUALIZACAO PARCEIROS
	static ISOLVE_VISUALIZACAO_TABELAS_PERFIL_ADMINISTRADOR = 'Isolve.VisualizacaoTabelas.PerfilAdministrador'
	static ISOLVE_VISUALIZACAO_TABELAS_PERFIL_FRANQUEADO = 'Isolve.VisualizacaoTabelas.PerfilFranqueado'
	static ISOLVE_VISUALIZACAO_TABELAS_PERFIL_CONSULTOR = 'Isolve.VisualizacaoTabelas.PerfilConsultor'
	static ISOLVE_VISUALIZACAO_TABELAS_PERFIL_CASA_MINEIRA = 'Isolve.VisualizacaoTabelas.PerfilCasaMineira'
	static ISOLVE_VISUALIZACAO_TABELAS_PERFIL_NAVENT = 'Isolve.VisualizacaoTabelas.PerfilNavent'
	static ISOLVE_VISUALIZACAO_TABELAS_PERFIL_QUINTO_ANDAR = 'Isolve.VisualizacaoTabelas.PerfilQuintoAndar'
	static ISOLVE_PROPOSTAS_SOMENTE_LEITURA = 'Isolve.Geral.SomenteLeitura'
	static ISOLVE_VISUALIZACAO_PROPOSTAS_FILA_DE_TRABALHO = 'Isolve.MinhasPropostas.FiltroFilaDeTrabalho'
	static ISOLVE_VISUALIZACAO_TABELAS_PERFIL_CORRETOR = 'Isolve.VisualizacaoTabelas.PerfilCorretor'
	static ISOLVE_VISUALIZACAO_TABELAS_PERFIL_PARCEIRO = 'Isolve.VisualizacaoTabelas.PerfilParceiro'
	static ISOLVE_USUARIOS_SOMENTE_LEITURA = 'Isolve.usuarios.SomenteLeitura'
	static ISOLVE_USER_NOTIFICATION = 'Isolve.Geral.ModuloNotificacoes'
	static ISOLVE_PILOT_RULES_SHOW_NEW_PRE_ANALISYS_BUTTON = 'Isolve.PilotsAndExceptionsRules.ShowNewPreAnalisysButton'
	static ISOLVE_PILOT_EXCEPTION_RULES_PARAMETRIZACAO_PARCEIRO = 'Isolve.PilotsAndExceptionsRules.ParametrizacaoParceiro'

	static ISOLVE_HIDE_NEW_PRE_ANALISY = 'Isolve.PreAnalise.OcultarNovaPreAnalise'
	static ISOLVE_SHOW_COPY_FORM_LINK = 'Isolve.PreAnalise.CopiarFormularioCredito'

	static ISOLVE_CLOSING_START_CONCILIATION = 'Isolve.FechamentoFinanceiro.IniciarConciliacao'
	static ISOLVE_CLOSING_MANAGEMENT_FLOW = 'Isolve.FechamentoFinanceiro.Fluxogerencial'
	static ISOLVE_CLOSING_FINALIZE_RECONCILIATION = 'Isolve.FechamentoFinanceiro.FinalizarConciliacao'
	static ISOLVE_CLOSING_ALLOW_ADM_ROUTINES = 'Isolve.FechamentoFinanceiro.AcessoRotinaAdm'

	static ISOLVE_APROVE_COMMISSION = 'Isolve.FechamentoFinanceiro.AprovarComissoes'

	static ISOLVE_CLOSING_DELETE_REPORT = 'Isolve.FechamentoFinanceiro.RemoverRelatorio'

	static ISOLVE_IPO_CUSTOMER_DATA_EDIT = 'Isolve.IPOGestaoDeMudancaDaInformacao.AlterarDadosCliente'
}
